import ServiceSettings from "../settings";

const BaseURL = ServiceSettings.apiURL;
export {BaseURL};
